import $ from "jquery";


const _document = $(document);
const _menu     = $(".menu");
const _header   = $(".header__primary");


const _body       = $('body');
const _menuButton = $(".menu-button");
const _searchClose  = $(".search-close");


const _search       = $(".predictive-search");
const _searchButton = $(".search-button");
const _searchReset  = $(".search-reset");


const closeMenu = function(e) {
   if ((!_search.is(e.target) && _search.has(e.target).length === 0) && (!_menu.is(e.target) && _menu.has(e.target).length === 0) && (!_header.is(e.target) && _header.has(e.target).length === 0)) {
      //console.log("CLOSE MENU");
      _body.removeClass("show-menu");
      _body.removeClass("show-search");
   }
};

const openCloseMenu = function(e) {

   e.preventDefault();

   //console.log("CloseMenu", !_body.hasClass('show-search'), !_body.hasClass('show-filters'), !_body.hasClass('show-menu'));

   if (!_body.hasClass('show-search') && !_body.hasClass('show-filters') && !_body.hasClass('show-menu')) {
      _body.addClass("show-menu");
   } else {
      _body.removeClass("show-menu");
   }

   if (_body.hasClass('show-search')){
      _body.removeClass("show-search");
   } 
   if (_body.hasClass('show-filters')){
      _body.removeClass("show-filters");
   } 
   
}

const openCloseSearch = function(e) {
   e.preventDefault();
   _body.removeClass("show-menu");
   if (_body.hasClass('show-search')){
      _body.removeClass("show-search");
   } else {
      _body.addClass("show-search");
      // Give focus to the search input after a small delay to ensure the search is visible
      setTimeout(function() {
         $("#header-search-input").focus();
      }, 500);
   }
 }

export const initMenu = function() {

   console.log("Init Menu");
   _menuButton.on("click",openCloseMenu);
   _searchClose.on("click",openCloseMenu);
   _searchButton.on("click",openCloseSearch);
   _searchReset.on("click",openCloseSearch);
   _document.on( "mouseup",closeMenu);

};